
import { useEffect, useState } from "react";
import Confetti from "react-confetti";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

const OrderConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const sendOrderConfirmationEmail = async () => {
      const orderId = new URLSearchParams(location.search).get('orderId');
      
      if (!orderId) {
        console.error('No orderId found in URL parameters');
        return;
      }

      console.log('Sending confirmation email for order:', orderId);

      try {
        const { error } = await supabase.functions.invoke('send-order-confirmation', {
          body: { orderId }
        });

        if (error) {
          console.error('Error sending confirmation email:', error);
          throw error;
        }
        
        console.log('Confirmation email sent successfully');
      } catch (error: any) {
        console.error('Error sending confirmation email:', error);
        toast({
          title: "Notification Error",
          description: "We couldn't send you a confirmation email right now, but your order has been placed successfully. You can view your order details in your account.",
          variant: "destructive",
        });
      }
    };

    sendOrderConfirmationEmail();
  }, [location.search, toast]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <Confetti
        width={windowSize.width}
        height={windowSize.height}
        recycle={false}
        numberOfPieces={200}
        gravity={0.2}
      />
      
      <div className="text-center space-y-6 max-w-md mx-auto p-6">
        <div className="flex justify-center">
          <CheckCircle2 className="h-24 w-24 text-green-500" />
        </div>
        
        <h1 className="text-3xl font-bold">Order Confirmed!</h1>
        <p className="text-muted-foreground">
          Thank you for your order. We've sent a confirmation email with all the details.
        </p>
        
        <div className="pt-6 space-y-4">
          <Button
            onClick={() => navigate("/")}
            className="w-full"
          >
            Browse More Meals
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate("/meals")}
            className="w-full"
          >
            View Order History
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
